<template>
  <div v-if="news" class="page-wrapper container-custom ">
    <div class=" heading">
      <TitlesDescriptionComponent :size="'small'" :title="$t('news-page-title')"/>
    </div>
    <div class="row news-container">

      <div v-for="(item, index) in news" :key="index" class="col-md-3 service-thumbnails-container">
        <router-link :to="{name: 'OneNewsView', params: { id: item.id } }">
          <OneNewsPostThumbnail
              :id="item.id"
              :img-src="item.content.imageUrl"
              :subtitle="item.content.subTitle"
              :title="item.content.title"
          />
        </router-link>

      </div>
    </div>

  </div>
</template>

<script>


import TitlesDescriptionComponent
  from "@/components/Components/TitlesDescriptionComponent/TitlesDescriptionComponent.vue";
import OneNewsPostThumbnail from "@/components/Components/OneNewsPostThumbnail/OneNewsPostThumbnail.vue";

export default {
  name: 'NewsView',
  components: {
    TitlesDescriptionComponent,
    OneNewsPostThumbnail

  },

  data() {
    return {
      news: null,
    };
  },
  async mounted() {
    const response = await this.$store.dispatch("news/getNews", {
      limit: 50
    });
    this.news = response.data
  },


};

</script>

<style lang="scss" scoped>
@import "~@/assets/scss/fonts.scss";

.page-wrapper {
  font-family: $font-regular;
}

.heading {
  margin-top: 90px;
}


@media screen and (min-width: 768px) {
  .heading {
    margin-top: 120px;
  }
  .news-container {
    margin-bottom: 50px;
  }

}
</style>